import React from "react";
import style from "../administration/UserManagement/AirlineRepModal/airlineRepModal.module.css";
import commonStyles from "../common/common.module.css";
import { Button, Grid, withStyles, createStyles, Theme, DialogTitle, IconButton, Dialog, DialogContent, } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import AwbBasic from "../../models/AwbBasic";

interface SuspendConfirmModalProps {
  modalOpen: boolean;
  handleClose: () => void;
  classes: any;
  suspensionReason: string;
  onChange: (event: any) => void;
  suspendOrder: () => void;
  type: string;
  error: string;
}

const styles = (theme: Theme) =>
  createStyles({
    formField: {
      height: 40,
      width: "100%",
    },
    rowContainer: {
      paddingRight: 20,
    },
    marginTop10: {
      marginTop: 10,
    },
  });

const suspendConfirmModal = (props: SuspendConfirmModalProps) => {
  return (
    <Dialog
      open={props.modalOpen}
      onClose={props.handleClose}
      aria-labelledby="form-dialog-title"
      maxWidth={"sm"}
      fullWidth={true}
    >
      <DialogTitle id="form-dialog-title">
        <div className={commonStyles.dialogTitle}>
        <div className={commonStyles.name}>{props.type == 'suspend' ? 'Suspend Order' : 'Reactivate suspended order'}</div>
          <IconButton
            aria-label="Close"
            className={style.close}
            onClick={props.handleClose}
          >
            <CloseIcon color="primary" />
          </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        <div>
          <div className={ `${ commonStyles.wrapper } ${ commonStyles.inputLabelWrapper }` } >
            <label className={ commonStyles.inputLabel }>{props.type == 'suspend' ? 'Enter reason for suspension' : 'Enter reason for reactivation'}</label>
            {/* <input
                className={style.inputField}
                type="text"
                placeholder={ props.type == 'suspend' ?  "Enter reason for suspension" : "Reason for reactivation"}
                value={ props.suspensionReason }
                onChange={  props.onChange }
              /> */}
              <textarea
                className={style.inputField}
                placeholder={ props.type == 'suspend' ?  "Enter reason for suspension" : "Reason for reactivation"}
                value={ props.suspensionReason }
                onChange={ props.onChange }
                rows={4}
              />
              { props.error && <div className={style.errorText}>{ props.error }</div> }
          </div>
          <div className={`${style.buttonContainerSuspend}`}>
            <button className={style.suspendButton} onClick={ props.handleClose }>Close</button>
            <button className={style.suspendButton} disabled={props.suspensionReason.trim() === ""} onClick={ props.suspendOrder }>{props.type == 'suspend' ? 'Suspend Order' : 'Reactivate'}</button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default withStyles(styles)(suspendConfirmModal);